import { Link } from "react-router-dom";
import { Hexagon, ArrowLeft } from "lucide-react";
import SeoHead from "@/components/SeoHead";

const NotFound = () => (
  <div className="min-h-screen bg-[#FAF8F5] honey-grain font-body text-zinc-900 grid place-items-center px-5">
    <SeoHead title="Page not found | HoneyGain Deals" description="This page doesn't exist." path="/404" />
    <div className="text-center max-w-md" data-testid="not-found-page">
      <span className="inline-grid place-items-center w-14 h-14 rounded-2xl bg-amber-400 text-zinc-900">
        <Hexagon className="w-7 h-7" strokeWidth={2.5} />
      </span>
      <h1 className="mt-6 font-display text-3xl sm:text-4xl font-extrabold tracking-tight">This page doesn't exist</h1>
      <p className="mt-3 text-zinc-600">
        The link may be old or mistyped. Head back to the homepage or read the blog instead.
      </p>
      <div className="mt-8 flex items-center justify-center gap-3">
        <Link
          to="/"
          data-testid="not-found-home-link"
          className="inline-flex items-center gap-2 rounded-full bg-zinc-900 px-6 py-3 font-display text-sm font-bold text-white hover:bg-amber-500 hover:text-zinc-900 transition-colors"
        >
          <ArrowLeft className="w-4 h-4" /> Back to homepage
        </Link>
        <Link
          to="/blog"
          data-testid="not-found-blog-link"
          className="inline-flex items-center gap-2 rounded-full border border-zinc-200 bg-white px-6 py-3 font-display text-sm font-bold text-zinc-800 hover:border-amber-400 transition-colors"
        >
          Read the blog
        </Link>
      </div>
    </div>
  </div>
);

export default NotFound;
